<div class="p-col-12 p-p-2">
	<span class="p-inputgroup">
		<input [maxlength]="maxlength" [ngClass]="ngClass" type="text" pInputText [(ngModel)]="value"
			(ngModelChange)="onChange()" [disabled]="disabled" style="width: 100%" placeholder="{{label|translate}}">
        <div class="p-inputgroup-addon">{{typeWeight|translate}}</div>
	</span>
</div>
